import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import {
  collection,
  getDocs,
  getFirestore,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { FirebaseApp } from "firebase/app";
import StreamingItem from "./StreamingItem";
import { getMembersFromFirestore, MemberInfo } from "../common/common";

type Props = {
  firebaseApp: FirebaseApp;
};
function StreamingSchedule(props: Props) {
  interface StreamingData {
    [key: string]: any;
  }

  const [data, setData] = useState<StreamingData>({});
  const [memberList, setMemberList] = useState<MemberInfo[]>([]);
  const { firebaseApp } = props;

  useEffect(() => {
    // console.log("Get data from Firestore");
    const getDataFromFirestore = async () => {
      const db = getFirestore(firebaseApp);
      const since = new Date();
      // 2 days ago
      since.setDate(since.getDate() - 2);
      const q = query(
        collection(db, "videos"),
        where(
          "liveStreamingDetails.scheduledStartTime",
          ">=",
          since.toISOString()
        ),
        orderBy("liveStreamingDetails.scheduledStartTime", "desc")
      );
      const d: StreamingData = {};
      getDocs(q).then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          d[doc.id] = doc.data();
        });
        setData(d);
      });
    };
    getDataFromFirestore();
    getMembersFromFirestore(firebaseApp, setMemberList);
  }, [firebaseApp]);

  const getItems = () => {
    const items: any = [];
    Object.keys(data).forEach((key) => {
      const o = data[key];
      let url = "";
      let w = 0;
      let h = 0;
      if ("high" in o.thumbnails) {
        url = o.thumbnails.high.url;
        w = o.thumbnails.high.width;
        h = o.thumbnails.high.height;
      } else {
        url = o.thumbnails.medium.url;
        w = o.thumbnails.medium.width;
        h = o.thumbnails.medium.height;
      }
      const date = new Date(o.liveStreamingDetails.scheduledStartTime);
      const timeOfDay = `${`000${date.getHours().toString()}`.slice(
        -2
      )}:${`000${date.getMinutes().toString()}`.slice(-2)}`;
      const startTime = `${(date.getMonth() + 1).toString()}/${date
        .getDate()
        .toString()} ${timeOfDay}`;
      items.push(
        <StreamingItem
          key={`${key}-si`}
          videoId={key}
          url={url}
          w={w}
          h={h}
          title={o.title}
          channelTitle={o.channelTitle}
          channelId={o.channelId}
          startTime={startTime}
          timeOfDay={timeOfDay}
          memberList={memberList}
        />
      );
    });
    return items;
  };

  return (
    <Box>
      <Box boxShadow={3} sx={{}}>
        <Grid
          container
          justifyContent="center"
          columnSpacing={{ xs: 1, sm: 2, md: 4 }}
          m="0.5rem"
          p="0.5rem"
        >
          {getItems()}
        </Grid>
      </Box>
    </Box>
  );
}

export default StreamingSchedule;
